import React, { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";
import useLogger from "../util/Logger";
import { useAuth } from "./AuthHook";

const AssetsContext = createContext();

export default function AssetsProvider({ children }) {
  const logger = useLogger();
  const auth = useAuth();
  const [currentAssets, setCurrentAssets] = useState([]);

  const defaultAssets = [{ id: "Unknown", name: "Unknown" }];

  const updateAssets = async (propertyId) => {
    try {
      logger.debug(
        "AssetsProvider.updateAssets",
        `GET field/assets?propertyId=${propertyId}`
      );
      const data = await auth.get(`field/assets?propertyId=${propertyId}`);

      logger.debug("AssetsProvider.updateAssets", `Retrieved data`);

      const allSortedAssets = [
        ...defaultAssets,
        ...data.sort((a, b) => {
          if (a.name > b.name) return 1;
          if (a.name < b.name) return -1;
          return 0;
        }),
      ];

      setCurrentAssets(allSortedAssets);
      return allSortedAssets;
    } catch (error) {
      logger.debug(
        "AssetsProvider.updateAssets",
        `Failed to retrieve data: ${error}`
      );
      setCurrentAssets(defaultAssets);
      return defaultAssets;
    }
  };

  const getAssets = () => currentAssets;

  return (
    <AssetsContext.Provider
      value={{
        getAssets,
        updateAssets,
      }}
    >
      {children}
    </AssetsContext.Provider>
  );
}

AssetsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useAssets = () => useContext(AssetsContext);
